import type { GeneratedDoorPlacement } from "building-types/doors/doorTypes";
import type { WallCut } from "building-types/walls/wallCutTypes";
import type { WallSideDescriptor } from "building-types/walls/wallDesciptorTypes";
import type { WallSidePathDomain } from "building-types/walls/wallSideTypes";
import type { SolidWallMass, SolidWallSide, WallPath } from "building-types/walls/wallTypes";
import type { GeneratedWindowPlacement } from "building-types/windows/windowTypes";
import { closestParamNormalizedLine2 } from "geom/closestPoint";
import type { PolyLine2 } from "geom/polyLine2Types";
import { wallSidePathDomainNew } from "./wallSideUtils";

interface WallSideNewProps {
  windows?: GeneratedWindowPlacement[];
  doors?: GeneratedDoorPlacement[];
  wallCuts?: WallCut[];
  finishes?: SolidWallMass[];
  descriptor?: WallSideDescriptor;
}

export function wallSideNew(props: WallSideNewProps | undefined = undefined): SolidWallSide {
  return {
    descriptor: props?.descriptor ?? undefined,
    windows: props?.windows ?? [],
    doors: props?.doors ?? [],
    wallCuts: props?.wallCuts ?? [],
    finishes: props?.finishes ?? [],
  };
}

export function wallSideCopy(wallSide: SolidWallSide): SolidWallSide {
  return {
    ...wallSide,
    windows: wallSide?.windows?.slice(),
    doors: wallSide?.doors?.slice(),
    wallCuts: wallSide?.wallCuts?.slice(),
    finishes: wallSide?.finishes?.slice(),
  };
}

export function wallSidePathDomainFromEdge(sideAlignedPath: WallPath, sideAlignedEdge: PolyLine2): WallSidePathDomain {
  const sT = closestParamNormalizedLine2(
    sideAlignedPath.startX,
    sideAlignedPath.startY,
    sideAlignedPath.endX,
    sideAlignedPath.endY,
    sideAlignedEdge[0],
    sideAlignedEdge[1],
    false,
  );
  const eT = closestParamNormalizedLine2(
    sideAlignedPath.startX,
    sideAlignedPath.startY,
    sideAlignedPath.endX,
    sideAlignedPath.endY,
    sideAlignedEdge[2],
    sideAlignedEdge[3],
    false,
  );
  return wallSidePathDomainNew(sT, eT);
}
